export default class Fetch{

	constructor(){
		this.callback = null;
	}

	/**
	 * 
	 * @param {*} url 
	 * @param {*} data 
	 * 		class
	 * 		method
	 * 		...
	 * @returns object
	 */
	static async fetchJson(params = {}){

		const myRequest = new Request(params.url); //json file

		fetch(myRequest)
		.then(response => response.json())
		.then(data => {
			return data;
		})
		.catch(console.error);
		
	}

	static async send(params = {},callback=null){
		
		const url = params.url; 

		let formData = new FormData();

		formData.append( 'action', params.action );
		formData.append( 'data', params.data );
		formData.append( 'nonce',params.nonce); 

		try{
			const response = await fetch(url,
				{
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'X-WP-Nonce': params.nonce
					},
					body: formData,
				}
			);

			if(response.status==200){
				if(null != callback){
					return callback('Successful Update');
				}
			}
		}
		catch(e){
			console.log(e);
		}

	}
}